const colors = [
  '#07ead3',
  '#96ea0f',
];
/* 功率-推力曲线配置 */
export const getPowerTurbulentCurve = function(obj) {
  let powercurveOptions = {
     //color: colors,
    xAxis: {
      name: '风速（m/s）',
      type: 'value',
      splitNumber: 5,
      min: 0,
      max: 25,
      // nameGap: 75,
      nameLocation: 'center',
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      },
      axisLine: {
        lineStyle: {
          type: 'solid',
        }
      },
      axisLabel: {
        textStyle: {
        }
      },
      onZero: false
    },
    tooltip: {
      trigger: 'axis'
    },
    toolbox: {
      feature: {}
    },
    legend: {
      top: 15, 
      data: ['功率', '推力系数'],
      textStyle: {
      }
    },
    grid: {
      left: '4%',
      right: '6%',
      bottom: '6%',
      containLabel: true
    },
    yAxis: [
      {
        position: 'left',
        type: 'value',
        name: '功率（kW）',
        min: 0,
        max: value => {
          if (value.max <= 10) {
            return 12;
          }

          let max = value.max * 1.2;
          let val = max / 5;
          const round = true;
          const exponent = Math.floor(Math.log(val) / Math.LN10);
          const exp10 = Math.pow(10, exponent);
          const f = val / exp10; // 1 <= f < 10
          let nf;
          if (round) {
            if (f < 1.5) {
              nf = 1;
            } else if (f < 2.5) {
              nf = 2;
            } else if (f < 4) {
              nf = 3;
            } else if (f < 7) {
              nf = 5;
            } else {
              nf = 10;
            }
          } else {
            if (f < 1) {
              nf = 1;
            } else if (f < 2) {
              nf = 2;
            } else if (f < 3) {
              nf = 3;
            } else if (f < 5) {
              nf = 5;
            } else {
              nf = 10;
            }
          }
          val = nf * exp10;
          return val * 5 <= value.max ? val * 6 : val * 5;
        },
        axisLine: {
          lineStyle: {
            type: 'solid',
          },
        },
        axisLabel: {
          show: true,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      {
        position: 'right',
        type: 'value',
        name: '推力系数',
        axisLabel: {
          show: true,
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: 'dashed'
          }
        }
      }
    ],
    series: [
      {
        name: '功率',
        type: 'line',
        smooth: true,
        data: obj.power,
        yAxisIndex: '0'
      },
      {
        name: '推力系数',
        type: 'line',
        smooth: true,
        data: obj.thrust,
        yAxisIndex: '1'
      }
    ]
  };
  return powercurveOptions;
};

/* 多条功率曲线的配置 */
export const getMorePowerCurve = function(
  data,
  legends,
  serciesData,
  subtypeValue
) {
  let yxis = [];
  let yxisObj = {
    position: 'left',
    type: 'value',
    name: '',
    min: 0,
    max: value => {
      let max = value.max * 1.2;
      let val = max / 5;
      const round = true;
      const exponent = Math.floor(Math.log(val) / Math.LN10);
      const exp10 = Math.pow(10, exponent);
      const f = val / exp10; // 1 <= f < 10
      let nf;
      if (round) {
        if (f < 1.5) {
          nf = 1;
        } else if (f < 2.5) {
          nf = 2;
        } else if (f < 4) {
          nf = 3;
        } else if (f < 7) {
          nf = 5;
        } else {
          nf = 10;
        }
      } else {
        if (f < 1) {
          nf = 1;
        } else if (f < 2) {
          nf = 2;
        } else if (f < 3) {
          nf = 3;
        } else if (f < 5) {
          nf = 5;
        } else {
          nf = 10;
        }
      }
      val = nf * exp10;
      return val * 5;
    },
    axisLine: {
      lineStyle: {
        type: 'solid',
        color: '#222233'
      },
      textStyle: {
        color: '#222233'
      }
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#222233'
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed'
      }
    }
  };
  if (subtypeValue === '1') {
    yxisObj = {
      name: '功率（kW）',
      min: 0,
      max: value => {
        return value.max * 1.2;
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        },
        textStyle: {
          color: '#222233'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#222233'
        }
      },
      axisLine: {
        lineStyle: {
          type: 'solid',
          color: '#222233'
        },
        textStyle: {
          color: '#222233'
        }
      }
    };
    yxis.push(yxisObj);
  }
  if (subtypeValue === '2') {
    yxisObj.name = '推力系数';
    yxisObj.axisLabel = {
      show: true,
      textStyle: {
        color: '#222233'
      }
    };
    yxisObj.axisLine = {
      lineStyle: {
        type: 'solid',
        color: '#222233'
      },
      textStyle: {
        color: '#222233'
      }
    };
    yxis.push(yxisObj);
  }
  let powercurvesOptions = {
    backgroundColor: '#fff',
    color: colors,
    xAxis: {
      name: '风速(m/s)',
      type: 'value',
      splitNumber: 5,
      min: 0,
      max: 25,
      axisLine: {
        onZero: false,
        lineStyle: {
          type: 'solid',
          color: '#222233'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#222233'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        let res = '<span>' + params[0]['name'] + '</span>';
        for (let i = 0; i < params.length; i++) {
          res +=
            '<p>' + params[i].seriesName + ': ' + params[i].value[1] + '</p>';
        }
        return res;
      }
    },
    toolbox: {
      feature: {}
    },
    legend: {
      data: legends,
      textStyle: {
        color: '#222233'
      }
    },
    grid: {
      left: '3%',
      right: '8%',
      bottom: '3%',
      containLabel: true
    },
    yAxis: yxis,
    series: serciesData
  };
  return powercurvesOptions;
};

/* 获取对比功率曲线 */
export const getComparePowerCurve = function(
  data,
  dataLegends,
  turbineCheckedList,
  comparePowerCurveType,
  olddata
) {
  let yxid = [];
  let axid = {
    name: '风速(m/s)',
    type: 'value',
    splitNumber: 5,
    min: 0,
    max: value => {
      if (value.max <= 10) {
        return 10;
      }
      let max = value.max * 1.2;
      let val = max / 5;
      const round = true;
      const exponent = Math.floor(Math.log(val) / Math.LN10);
      const exp10 = Math.pow(10, exponent);
      const f = val / exp10; // 1 <= f < 10
      let nf;
      if (round) {
        if (f < 1.5) {
          nf = 1;
        } else if (f < 2.5) {
          nf = 2;
        } else if (f < 4) {
          nf = 3;
        } else if (f < 7) {
          nf = 5;
        } else {
          nf = 10;
        }
      } else {
        if (f < 1) {
          nf = 1;
        } else if (f < 2) {
          nf = 2;
        } else if (f < 3) {
          nf = 3;
        } else if (f < 5) {
          nf = 5;
        } else {
          nf = 10;
        }
      }
      val = nf * exp10;
      return val * 5;
    },
    axisLine: {
      lineStyle: {
        type: 'solid',
        color: '#222233'
      },
      onZero: false
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#222233'
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed'
      }
    }
  };

  if (comparePowerCurveType == 3) {
    yxid.push({
      position: 'left',
      type: 'value',
      name: '功率（kW）',
      min: 0,
      max: value => {
        if (value.max <= 10) {
          return 10;
        }

        let max = value.max * 1.2;
        let val = max / 5;
        const round = true;
        const exponent = Math.floor(Math.log(val) / Math.LN10);
        const exp10 = Math.pow(10, exponent);
        const f = val / exp10; // 1 <= f < 10
        let nf;
        if (round) {
          if (f < 1.5) {
            nf = 1;
          } else if (f < 2.5) {
            nf = 2;
          } else if (f < 4) {
            nf = 3;
          } else if (f < 7) {
            nf = 5;
          } else {
            nf = 10;
          }
        } else {
          if (f < 1) {
            nf = 1;
          } else if (f < 2) {
            nf = 2;
          } else if (f < 3) {
            nf = 3;
          } else if (f < 5) {
            nf = 5;
          } else {
            nf = 10;
          }
        }
        val = nf * exp10;
        return val * 5;
      },
      axisLine: {
        lineStyle: {
          type: 'solid',
          color: '#222233'
        },
        textStyle: {
          color: '#222233'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#222233'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      }
    });
  } else {
    yxid.push({
      position: 'left',
      type: 'value',
      name: '推力系数',
      axisLine: {
        lineStyle: {
          type: 'solid',
          color: '#222233'
        },
        textStyle: {
          color: '#222233'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#222233'
        }
      }
    });
  }

  // let dataSeries = turbineCheckedList.map((item, i) => {
  //   data.map(arr => {
  //     if (arr[0].turbineType === item.turbineType) {
  //       return {
  //         name: item.turbineType,
  //         type: 'line',
  //         data: data[i]
  //       };
  //     }
  //   });
  // });
  let dataSeries = olddata.map((arr, i) => {
    return {
      name: arr[0].turbineType,
      type: 'line',
      data: data[i]
    };
  });

  let newDataLegends = olddata.map(arr => {
    return arr[0].turbineType;
  });

  let powercurvecompareOptions = {
    backgroundColor: '#fff',
    color: colors,
    xAxis: axid,
    tooltip: {
      trigger: 'axis'
    },
    toolbox: {
      feature: {}
    },
    legend: {
      data: newDataLegends,
      textStyle: {
        color: '#222233'
      }
    },
    grid: {
      left: '3%',
      right: '6%',
      bottom: '3%',
      containLabel: true
    },
    yAxis: yxid,
    series: dataSeries
  };
  return powercurvecompareOptions;
};
